import type { NamedPathLookupAdvancedOptions } from './GraphAdvancedOptions';

export const factoryPathLookupAdvancedOptions: NamedPathLookupAdvancedOptions[] =
  [
    {
      dstRegions: '.*',
      enableRegions: false,
      factory: true,
      fragmentOffset: 0,
      id: 'echo',
      l4Options: {
        code: 0,
        type: 8,
      },
      name: 'Echo request',
      otherOptions: {
        applications: '(icmp|ping)',
        applicationsMatchWithRegex: true,
        tracked: false,
        url: '',
        category: '',
      },
      protocol: 'icmp',
      srcRegions: '.*',
      ttl: 128,
    },
    {
      dstRegions: '.*',
      enableRegions: false,
      factory: true,
      fragmentOffset: 0,
      id: 'echoForIpv6',
      l4Options: {
        code: 0,
        type: 128,
      },
      name: 'Echo request for Ipv6',
      otherOptions: {
        applications: '(icmpv6|ping)',
        applicationsMatchWithRegex: true,
        tracked: false,
        url: '',
        category: '',
      },
      protocol: 'icmpv6',
      srcRegions: '.*',
      ttl: 128,
    },
    {
      dstRegions: '.*',
      enableRegions: false,
      factory: true,
      fragmentOffset: 0,
      id: 'web',
      l4Options: {
        dstPorts: '80,443',
        flags: [],
        srcPorts: '1024-65535',
      },
      name: 'Web HTTP/HTTPS',
      otherOptions: {
        applications: '(web|http|https)',
        applicationsMatchWithRegex: true,
        tracked: false,
        url: '',
        category: '',
      },
      protocol: 'tcp',
      srcRegions: '.*',
      ttl: 128,
    },
  ];
